import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplaceCampaignInfluencerDaily.graphql';
import { Query, QuerymarketplaceCampaignReportArgs } from '../../__generated__/globalTypes';

export const useMarketplaceCampaignInfluencerDailyQuery = (
  options?: QueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplaceCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplaceCampaignInfluencerDailyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
): QueryResult<Query, QuerymarketplaceCampaignReportArgs> & {
  getMarketplaceCampaignInfluencerDaily: LazyQueryExecFunction<Query, QuerymarketplaceCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplaceCampaignInfluencerDaily, result] = useLazyQuery<Query, QuerymarketplaceCampaignReportArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getMarketplaceCampaignInfluencerDaily, ...result };
};

export const useMarketplaceCampaignInfluencerDailyPromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplaceCampaignInfluencerDaily = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplaceCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplaceCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplaceCampaignInfluencerDaily };
};
// Suspense Query Hooks
export const useMarketplaceCampaignInfluencerDailySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplaceCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplaceCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
